module.exports = __webpack_public_path__ + "media/images/smart_phone/menus/201809/top_images/2-9349e6dd720e35b16849b519d934b1ab.png";